import { render } from "./AuthorContentManager.vue?vue&type=template&id=592a0d20&scoped=true"
import script from "./AuthorContentManager.vue?vue&type=script&lang=js"
export * from "./AuthorContentManager.vue?vue&type=script&lang=js"

import "./AuthorContentManager.vue?vue&type=style&index=0&id=592a0d20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592a0d20"]])

export default __exports__